import { Stack } from "@mui/material";
import { PackageRegions } from "./PackageRegions";

const PublicPackagesRegionsPage = () => {
  return (
    <Stack
      spacing={1}
      sx={{
        marginTop: "1.5em",
      }}
    >
      <PackageRegions />
    </Stack>
  );
};

export default PublicPackagesRegionsPage;
